<template>
  <div class="menu-item-content" :class="{ 'collapsed': collapse }">
    <i v-if="icon" :class="['menu-icon', icon]" />
    <span v-if="!collapse" class="menu-title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    collapse: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.menu-item-content {
  display: flex;
  align-items: center;
  gap: 12px;
  
  &.collapsed {
    justify-content: center;
  }
  
  .menu-icon {
    font-size: 18px;
    flex-shrink: 0;
    color: inherit;
  }
  
  .menu-title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: opacity 0.3s ease;
  }
}
</style>
